package de.katoonerie.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.dom.Article
import org.w3c.dom.HTMLElement

@Composable
fun Prose(attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null, content: @Composable () -> Unit) {
    Article(attrs = {
        classes("prose")
        attrs?.invoke(this)
    }) {
        content()
    }
}
